import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useNavigator = () => {
    const history = useHistory();

    const goTo = (props) => {
        history.push(`/${props.page}`);

    }

    return {
        history,
        goTo
    };
}

export default useNavigator;